export default __webpack_public_path__ + "./img/ev_charging.png";